/*
 * $Id:: index.js 2021/03/02 03:44 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';

import Card from '../../../../components/Card';
import { t, bareDateTimeFormat } from '../../../../providers';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import { loading as loadingSlice } from '../../accountSlice';
import { SLICE_NAME } from '../../constants';
import ResetPasswordDialog from './ResetPasswordDialog';

const useStyles = makeStyles((theme) => ({
    changePasswordButton: {
        // height: '2rem',
        width: '9rem',
        marginBottom: '16px',
        marginLeft: 0,
    },
    fieldLabel: {
        color: theme.palette.text.label,
        fontSize: '0.625rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'normal',
    },
    fieldValue: {
        color: theme.palette.text.value,
        fontSize: '0.75rem',
        letterSpacing: 'normal',
        marginBottom: '10px',
    },
}));

const LoginDetails = () => {
    const dispatch = useDispatch();
    const me = useSelector(meSlice);
    const loading = useSelector(loadingSlice);

    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        const { username } = me;
        if (username && (!me || !me.email)) dispatch({ type: `${SLICE_NAME}/getAccountDetails`, payload: { userName: username } });
    }, [dispatch, me]);

    const classes = useStyles();

    const closeDialog = () => setDialogOpen(false);

    const changePassword = () => {
        setDialogOpen(true);
    };

    const renderItem = (
        <>
            <ResetPasswordDialog open={dialogOpen} closeDialog={closeDialog} />
            <Card title={'user.login.details'} canEdit={false} cardId={'login_details_card'}>
                <Typography aria-label={t('email.address')} className={classes.fieldLabel}>
                    {t('email.address')}
                </Typography>
                <Typography aria-label={me && me.email} className={classes.fieldValue}>
                    {(me && me.email) || '-'}
                </Typography>
                <Typography aria-label={t('password')} className={classes.fieldLabel}>
                    {t('password')}
                </Typography>
                <Button className={classes.changePasswordButton} variant="outlined" onClick={changePassword}>
                    {t('change.password')}
                </Button>
                <Typography aria-label={t('last.login')} className={classes.fieldLabel}>
                    {t('last.login')}
                </Typography>
                <Typography aria-label={me && me.lastLogin && bareDateTimeFormat(me.lastLogin, 'gmt')} className={classes.fieldValue}>
                    {(me && me.lastLogin && bareDateTimeFormat(me.lastLogin, 'gmt')) || '-'}
                </Typography>
                <Typography aria-label={t('failed.login.attempts')} className={classes.fieldLabel}>
                    {t('failed.login.attempts')}
                </Typography>
                <Typography aria-label={me && me.failedLoginNumber} className={classes.fieldValue}>
                    {(me && me.failedLoginNumber) || 0} {t('attempts')}
                </Typography>
            </Card>
        </>
    );

    return loading && !dialogOpen ? <CircularProgress /> : renderItem;
};

export default LoginDetails;
